// extracted by mini-css-extract-plugin
module.exports = {"whiteboardBrushColorItem":"WhiteboardBrushColorItem_whiteboardBrushColorItem__1xoWK","active":"WhiteboardBrushColorItem_active__3RnZi"};